
import Button from '../../../components/base/Button';

export default function ProductCTA() {
  return (
    <section className="py-16 bg-red-600">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            Need More Details or a Customized Quote?
          </h2>
          <p className="text-xl text-red-100 mb-8 leading-relaxed">
            Contact our expert team today for technical specifications, pricing information, 
            or custom fire protection solutions tailored to your specific requirements.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <Button 
              variant="secondary"
              className="flex-1 bg-white text-red-600 hover:bg-gray-100"
            >
              <i className="ri-message-3-line mr-2"></i>
              Request Quote
            </Button>
            <Button 
              variant="outline"
              className="flex-1 border-white text-white hover:bg-white hover:text-red-600"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Us Now
            </Button>
          </div>
          
          <div className="mt-8 pt-8 border-t border-red-500">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-red-100">
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span>Quick Response Time</span>
              </div>
              <div className="flex items-center">
                <i className="ri-shield-check-line mr-2"></i>
                <span>QCDD Certified</span>
              </div>
              <div className="flex items-center">
                <i className="ri-customer-service-2-line mr-2"></i>
                <span>Expert Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
